import React from 'react';
import DeviceStatus from './DeviceStatus';
import {Row} from 'react-flexbox-grid';
import branchIcon from '../../img/retail.svg';

import './BranchStatus.css'

export const BranchStatus = ({branchStatus}) => {
    return (
        <div className="BranchStatus">
            <img src={branchIcon} className="BranchIconStatus" alt="Branch icon"/>
            <h2 className="BranchStatusHeader">{branchStatus.branchName}</h2>
                <Row>
                    {branchStatus.deviceStatuses.map((d,i) => <DeviceStatus key={i} device={d}/>)}
                </Row>
        </div>
    );
};


export default BranchStatus;



// WEBPACK FOOTER //
// ./src/components/deviceStatus/BranchStatus.js